import { createElement } from 'react';
import { Renderable, Toast, toast, ValueOrFunction } from 'react-hot-toast';

import { ApplicationConfigurationService } from '@src/core/application-configuration';
import { Trans } from 'react-i18next';
import { translateText } from '@src/domain/common';
import { LocaleTranslationKeysEnum } from '@src/core/i18n/locale-translation-keys.enum';

export const createClickableSupportTeamErrorMessage = (
  reasonMessage: ValueOrFunction<Renderable, Toast>,
  supportTeamMessage: ValueOrFunction<Renderable, Toast>
) => {
  const reason = createElement(
    'span',
    {
      style: {
        display: 'inline',
        cursor: 'default',
      },
    },
    reasonMessage
  );

  const supportTeam = createElement(
    'a',
    {
      style: {
        display: 'inline',
        cursor: 'pointer',
      },
      href: ApplicationConfigurationService.getConfiguration().CONTACT_US,
      'data-testid': 'support-team',
      target: '_blank',
      rel: 'noreferrer',
    },
    createElement(
      Trans,
      {
        t: translateText,
        values: {
          operation: translateText(
            LocaleTranslationKeysEnum.SwoErrorWithUserAccessPermissionsSupport
          ),
        },
      },
      supportTeamMessage
    )
  );

  const fullMessage = createElement('div', undefined, reason, supportTeam);

  toast.error(fullMessage);
};

export const createClickableMessageElement = (
  message: ValueOrFunction<Renderable, Toast>,
  linkMessage: ValueOrFunction<Renderable, Toast>,
  linkHref: string,
  targetHref: string = '_self'
) => {
  const messageElement = createElement(
    'span',
    {
      style: {
        display: 'inline',
        cursor: 'default',
        marginRight: '1em',
      },
    },
    message
  );

  const linkMessageElement = createElement(
    'a',
    {
      style: {
        display: 'inline',
        cursor: 'pointer',
      },
      href: linkHref,
      'data-testid': 'success-link-href',
      target: targetHref,
      rel: 'noreferrer',
    },
    createElement(
      Trans,
      {
        t: translateText,
        values: {
          operation: translateText(
            LocaleTranslationKeysEnum.SwoErrorWithUserAccessPermissionsSupport
          ),
        },
      },
      linkMessage
    )
  );

  return createElement('div', undefined, messageElement, linkMessageElement);
};

export const createClickableSuccessMessage = (
  successMessage: ValueOrFunction<Renderable, Toast>,
  linkMessage: ValueOrFunction<Renderable, Toast>,
  linkHref: string,
  targetHref: string = '_self'
) => {
  const fullMessage = createClickableMessageElement(
    successMessage,
    linkMessage,
    linkHref,
    targetHref
  );

  toast.success(fullMessage, { duration: Infinity });
};
